// Textos de las pantallas (tal cual del diseño).

/** Textos de 1.13, tal cual del diseño. Los de «no contratada» y «sin nadie con PIN» no están dibujados (propuestos). */
export const TEXTOS_TABLET = {
    sinEmparejar: 'Tablet sin emparejar',
    empareja: 'Empareja esta tablet',
    // El diseño nombra la entrada del menú entera; el panel no escribe etiquetas del menú (las da el servidor, arquitectura.test).
    emparejaSub: 'Escribe el código de Equipo › Tablets.',
    codigoMalo: 'El código no es correcto o ha caducado.',
    quien: '¿Quién eres?',
    toca: 'Toca tu nombre',
    nadie: 'Aún no hay nadie con PIN en esta tablet. Cada persona elige el suyo en Mi cuenta.',
    pinBloqueado: 'PIN bloqueado',
    // Encargo de la exportación del 2026-10-22, punto 25 (G337): aún sin dibujo.
    emparejadaCon: (negocio: string, tablet: string) => `Emparejada con ${negocio} · ${tablet}`,
    bloqueadoHasta: (hora: string) => `Bloqueado hasta las ${hora}`,
    noSoy: (nombre: string) => `No soy ${nombre}`,
    hola: (nombre: string) => `Hola, ${nombre}`,
    escribePin: 'Escribe tu PIN',
    pinMalo: 'El PIN no es correcto.',
    entrar: 'Entrar',
    bloqueadoTitulo: 'PIN bloqueado',
    bloqueadoTexto: (nombre: string) =>
        `${nombre}, ha habido 5 intentos fallidos. Se desbloquea en 15 minutos o en cuanto elijas un PIN nuevo en Mi cuenta. Si no lo recuerdas, pide a quien gestiona el equipo un PIN nuevo.`,
    otraPersona: 'Elegir otra persona',
    cambiar: 'Cambiar de persona',
    aquiSeAbre: 'Aquí se abre Puerta, Sala o Taquilla',
    seDisenan: 'Se diseñan en su módulo',
    seCierra: 'Se cierra sola tras 10 minutos sin tocarla',
    revocada: 'Esta tablet ya no está emparejada',
    revocadaSub: 'Pide un código nuevo a quien gestiona el equipo.',
    deNuevo: 'Emparejar de nuevo',
    noContratada: 'Esta tablet no está contratada',
    noContratadaSub: 'El escáner y la tablet son un bloque del plan. Pide a quien lleva el negocio que lo añada.',
} as const;
